import { useEffect, useRef, type ReactElement } from 'react'
import { usePathname } from 'shared/hooks/useRouterPath'
import { sendGTMEvent } from 'shared/googleTagManager'
import ErrUnExpected from './Error/UnExpected'

export interface FallbackProps {
  error: Error | null | undefined
  resetError: () => void
  hasDashboardFrame?: boolean
}

export const ErrorFallback = function ({ error, resetError, hasDashboardFrame = false }: FallbackProps): ReactElement {
  const { pathnameWithQueryParams } = usePathname()

  const prevPathnameRef = useRef(pathnameWithQueryParams)

  useEffect(() => {
    if (prevPathnameRef.current !== pathnameWithQueryParams) {
      resetError()
    }
    prevPathnameRef.current = pathnameWithQueryParams
  }, [pathnameWithQueryParams, resetError])

  useEffect(() => {
    if (error != null) {
      sendGTMEvent({
        event: 'unexpected_error',
        error_message: error.message,
        page_path: globalThis.location.pathname,
        timestamp: new Date().toISOString()
      })
    }
  }, [error])

  return <ErrUnExpected error={error} hasDashboardFrame={hasDashboardFrame} />
}
